import React, { useRef } from "react";
import { Button } from "@mui/material";
import { PrintOutlined } from "@mui/icons-material";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useAppSelector } from "../../../../../app/hooks";
import { useCaseFindQuery } from "../../../../../services/scheduleService/schedule-api";
import { useCenterFindQuery } from "../../../../../services/orgService/org-api";
import { useParams } from "react-router";
import { formatNumber, formatDate } from "@telerik/kendo-intl";
import { Grid } from "@mui/material";

function GoodFaithEstimateExportBtn() {
    const { id } = useParams();
    const schedule = useCaseFindQuery(id!);
    const verify = useAppSelector((state) => state.verification.verification);
    const center = useCenterFindQuery(id!.split('-')[0]);
    const pdfExportComponent = useRef<PDFExport>(null);

    if (!center.data) return null;

    const firstName = schedule.data?.firstName || verify.firstName || '';
    const lastName = schedule.data?.lastName || verify.lastName || '';
    const patientBirthDate = schedule.data?.birthDate || verify.birthDate;
    const serviceDate = schedule.data?.serviceDate || verify.serviceDate;

    const handleExport = () => {
        if (pdfExportComponent.current) {
            pdfExportComponent.current.save();
        }
    };

    return (
        <React.Fragment>
            <Button
                variant="contained"
                sx={{ backgroundColor: '#62BCBD' }}
                size="small"
                startIcon={<PrintOutlined />}
                onClick={handleExport}
            >
                good faith est
            </Button>
            <div style={{ position: 'absolute', left: '-100000px', top: 0 }}>
                <PDFExport
                    paperSize="a4"
                    margin="1cm"
                    ref={pdfExportComponent}
                    fileName={lastName + ', ' + firstName + ' ' + verify.accountNumber + '.pdf'}
                >
                    <div>
                        <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '12pt', marginBottom: 4 }}>
                            {center.data.name}
                        </div>
                        <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '14pt', marginBottom: 12 }}>
                            Good Faith Estimate for Health Care Items and Services
                        </div>
                        
                        {/* Patient Information Section */}
                        <div style={{ fontSize: '10pt', fontWeight: 'bold', textDecoration: 'underline', marginBottom: 8 }}>Patient</div>
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Patient First Name</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{firstName}</div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Middle Name</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{schedule.data?.middleName || ''}</div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Last Name</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{lastName}</div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Patient Date of Birth: ___/___/___</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{patientBirthDate ? formatDate(new Date(patientBirthDate), "MM/dd/yyyy") : ''}</div>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Patient Identification Number:</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{verify.accountNumber}</div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <div style={{ fontSize: '10pt', fontWeight: 'bold', textDecoration: 'underline', marginBottom: 8 }}>Patient Mailing Address, Phone Number, and Email Address</div>
                        <Grid container spacing={1}>
                            <Grid item xs={8}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Street or PO Box</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{schedule.data?.streetAddress1 || ''}</div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Apartment</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{schedule.data?.streetAddress2 || ''}</div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>City</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{schedule.data?.city || ''}</div>
                            </Grid>
                            <Grid item xs={2}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>State</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{schedule.data?.state || ''}</div>
                            </Grid>
                            <Grid item xs={3}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>ZIP Code</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{schedule.data?.zipCode || ''}</div>
                            </Grid>
                            <Grid item xs={3}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Phone</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{schedule.data?.homePhone || schedule.data?.mobilePhone || verify.preQuoteAttributes?.phoneNumber || ''}</div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Email Address</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{schedule.data?.email || ''}</div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <div style={{ fontSize: '9pt' }}>
                            <span style={{ fontWeight: 'bold' }}>Patient's Contact Preference:</span>
                            <span style={{ marginLeft: 20 }}>☐ By mail</span>
                            <span style={{ marginLeft: 20 }}>☐ By email</span>
                        </div>
                        <br />
                        
                        {/* Service Scheduling and Cost Information */}
                        <div style={{ fontSize: '10pt', fontWeight: 'bold', marginBottom: 8 }}>
                            If scheduled, list the date(s) the Primary Service or Item will be provided:
                        </div>
                        <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt', marginBottom: 12 }}>
                            {serviceDate ? formatDate(new Date(serviceDate), "MM/dd/yyyy") : ''}
                        </div>
                        
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '10pt', fontWeight: 'bold' }}>Date of Good Faith Estimate: ___/___/___</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{formatDate(new Date(), "MM/dd/yyyy")}</div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <div style={{ fontSize: '10pt', fontWeight: 'bold', textDecoration: 'underline', marginBottom: 8, textAlign: 'center' }}>Provider Estimated Costs</div>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '10pt', fontWeight: 'bold', textDecoration: 'underline' }}>Provider Name</div>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '10pt', fontWeight: 'bold', textDecoration: 'underline' }}>Estimated Total Cost</div>
                            </Grid>
                        </Grid>
                        
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{center.data.name}</div>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{formatNumber(verify.patientResponsibility.collectFromPatient, 'c')}</div>
                            </Grid>
                        </Grid>
                        
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}></div>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}></div>
                            </Grid>
                        </Grid>
                        
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}></div>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}></div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '10pt', fontWeight: 'bold' }}>Total Estimated Cost:</div>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '10pt', fontWeight: 'bold' }}>{formatNumber(verify.patientResponsibility.collectFromPatient, 'c')}</div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        {/* Detailed Service Information */}
                        <div style={{ fontSize: '10pt', marginBottom: 12 }}>
                            The following is a detailed list of expected charges for {verify.procedures?.map(p => p.description).join(', ') || '[LIST PRIMARY SERVICE OR ITEM]'}, 
                            {serviceDate ? ` scheduled for ${formatDate(new Date(serviceDate), "MM/dd/yyyy")}` : ' [LIST DATE OF SERVICE, IF SCHEDULED]'}.
                            The estimated costs are valid for 12 months from the date of the Good Faith Estimate.
                        </div>
                        
                        {/* Provider/Facility 1 Estimate Section */}
                        <div style={{ fontSize: '12pt', fontWeight: 'bold', textDecoration: 'underline', marginBottom: 12 }}>
                            Provider/Facility 1 Estimate
                        </div>
                        
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Provider/Facility Name</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{center.data.name}</div>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Provider/Facility Type</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}></div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Street Address</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{center.data.streetAddress1 || ''}</div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>City</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{center.data.city}</div>
                            </Grid>
                            <Grid item xs={2}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>State</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{center.data.state}</div>
                            </Grid>
                            <Grid item xs={3}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>ZIP Code</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{center.data.zip || ''}</div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Contact Person</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}></div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Phone</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}></div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Email</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}></div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>National Provider Identifier</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{center.data.npi || ''}</div>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Taxpayer Identification Number</div>
                                <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '12pt' }}>{center.data.taxId || ''}</div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <div style={{ fontSize: '10pt', fontWeight: 'bold', textDecoration: 'underline', marginBottom: 8 }}>
                            Details of Services and Items for {center.data.name}
                        </div>
                        
                        <Grid container spacing={1}>
                            <Grid item xs={3}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Service/Item</div>
                            </Grid>
                            <Grid item xs={3}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Address where service/item will be provided</div>
                            </Grid>
                            <Grid item xs={2}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Diagnosis Code</div>
                            </Grid>
                            <Grid item xs={1.5}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Service Code</div>
                            </Grid>
                            <Grid item xs={1}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Quantity</div>
                            </Grid>
                            <Grid item xs={1.5}>
                                <div style={{ fontSize: '8pt', fontWeight: 'bold' }}>Expected Cost</div>
                            </Grid>
                        </Grid>
                        
                        {verify.procedures?.map((procedure, index) => (
                            <Grid container spacing={1} key={index} style={{ marginBottom: '12px' }}>
                                <Grid item xs={3}>
                                    <div style={{ fontSize: '8pt', borderBottom: '1px solid black', minHeight: '20pt', paddingBottom: '2pt', lineHeight: '1.2' }}>{procedure.description}</div>
                                </Grid>
                                <Grid item xs={3}>
                                    <div style={{ fontSize: '8pt', borderBottom: '1px solid black', minHeight: '20pt', paddingBottom: '2pt', lineHeight: '1.2' }}>{center.data?.streetAddress1 || ''}, {center.data?.city || ''}, {center.data?.state || ''}, {center.data?.zip || ''}</div>
                                </Grid>
                                <Grid item xs={2}>
                                    <div style={{ fontSize: '8pt', borderBottom: '1px solid black', minHeight: '20pt', paddingBottom: '2pt', lineHeight: '1.2' }}>
                                        {[verify.diagnosisCodes?.diagnosis1, verify.diagnosisCodes?.diagnosis2, verify.diagnosisCodes?.diagnosis3, verify.diagnosisCodes?.diagnosis4]
                                            .filter(code => code && code.trim() !== '')
                                            .join(', ')}
                                    </div>
                                </Grid>
                                <Grid item xs={1.5}>
                                    <div style={{ fontSize: '8pt', borderBottom: '1px solid black', minHeight: '20pt', paddingBottom: '2pt', lineHeight: '1.2' }}>{procedure.code}</div>
                                </Grid>
                                <Grid item xs={1}>
                                    <div style={{ fontSize: '8pt', borderBottom: '1px solid black', minHeight: '20pt', paddingBottom: '2pt', lineHeight: '1.2' }}>1</div>
                                </Grid>
                                <Grid item xs={1.5}>
                                    <div style={{ fontSize: '8pt', borderBottom: '1px solid black', minHeight: '20pt', paddingBottom: '2pt', lineHeight: '1.2' }}>{formatNumber(procedure.reimbursement, 'c')}</div>
                                </Grid>
                            </Grid>
                        ))}
                        <br />
                        
                        <Grid container spacing={1}>
                            <Grid item xs={8}>
                                <div style={{ fontSize: '10pt', fontWeight: 'bold' }}>Total Expected Charges from {center.data.name}</div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ fontSize: '10pt', fontWeight: 'bold' }}>{formatNumber(verify.patientResponsibility.collectFromPatient, 'c')}</div>
                            </Grid>
                        </Grid>
                        <br />
                        
                        <div style={{ fontSize: '10pt', fontWeight: 'bold', marginBottom: 8 }}>
                            Additional Health Care Provider/Facility Notes
                        </div>
                        <div style={{ fontSize: '9pt', borderBottom: '1px solid black', minHeight: '24pt', marginBottom: 12 }}>
                        </div>
                        
                        {/* Disclaimer Section */}
                        <div style={{ fontSize: '12pt', fontWeight: 'bold', textAlign: 'center', marginTop: 20, marginBottom: 12 }}>
                            Disclaimer
                        </div>
                        
                        <div style={{ fontSize: '9pt', lineHeight: '1.3', marginBottom: 12 }}>
                            This Good Faith Estimate shows the costs of items and services that are reasonably expected for your health care needs for an item or service. The estimate is based on information known at the time the estimate was created, and actual items, services, or charges may differ from this Good Faith Estimate.
                        </div>
                        
                        <div style={{ fontSize: '9pt', lineHeight: '1.3', marginBottom: 12 }}>
                            We may recommend the following items or services as part of the course of care, which will require separate scheduling and are expected to occur before or immediately following the expected period of care for the primary item or service. 
                            For items or services included in this list, information such as diagnosis codes, service codes, expected charges and provider or facility identifiers are not included in this good faith estimate, as that information will be provided in separate good faith estimates upon scheduling or upon request of such items or services. You can obtain good faith estimates for these items or services by contacting our business office and speaking to one of our Patient Access Representatives who will gladly assist you.
                        </div>
                        
                        <div style={{ fontSize: '10pt', fontWeight: 'bold', marginBottom: 8 }}>
                            List of Items or Services Requiring Separate Scheduling
                        </div>
                        <div style={{ fontSize: '9pt', minHeight: '12pt', marginBottom: 4 }}>
                            _______________________________________________________________
                        </div>
                        <div style={{ fontSize: '9pt', minHeight: '12pt', marginBottom: 4 }}>
                            _______________________________________________________________
                        </div>
                        <div style={{ fontSize: '9pt', minHeight: '12pt', marginBottom: 4 }}>
                            _______________________________________________________________
                        </div>
                        <div style={{ fontSize: '9pt', minHeight: '12pt', marginBottom: 4 }}>
                            _______________________________________________________________
                        </div>
                        
                        <div style={{ fontSize: '9pt', lineHeight: '1.3', marginBottom: 12 }}>
                            This Good Faith Estimate does not include any unknown or unexpected costs that may arise during treatment. You could be charged more if complications or special circumstances occur. If this happens, federal law allows you to dispute (appeal) the bill.
                        </div>
                        
                        <div style={{ fontSize: '9pt', lineHeight: '1.3', marginBottom: 12 }}>
                            This good faith estimate is not a contract and does not require you to obtain the items or services from any of the providers or facilities identified in the good faith estimate.
                        </div>
                        
                        <div style={{ fontSize: '11pt', lineHeight: '1.3', marginBottom: 8, fontWeight: 'bold' }}>
                            If you are billed for more than this Good Faith Estimate, you have the right to dispute the bill.
                        </div>
                        
                        <div style={{ fontSize: '9pt', lineHeight: '1.3', marginBottom: 12 }}>
                            You may contact the health care provider or facility listed to let them know the billed charges are higher than the Good Faith Estimate. You can ask them to update the bill to match the Good Faith Estimate, ask to negotiate the bill, or ask if there is financial assistance available.
                        </div>
                        
                        <div style={{ fontSize: '9pt', lineHeight: '1.3', marginBottom: 12 }}>
                            You may also start a dispute resolution process with the U.S. Department of Health and Human Services (HHS) if this Good Faith Estimate is $400 or more than your actual charges. If you choose to use the dispute resolution process, you must start the dispute process within 120 calendar days (about 4 months) of the date on the original bill.
                        </div>
                        
                        <div style={{ fontSize: '9pt', lineHeight: '1.3', marginBottom: 12 }}>
                            There is a $25 fee to use the dispute process. If the agency reviewing your dispute agrees with you, you will have to pay the price on this Good Faith Estimate. If the agency disagrees with you and agrees with the health care provider or facility, you will have to pay the higher amount.
                        </div>
                        
                        <div style={{ fontSize: '9pt', lineHeight: '1.3', marginBottom: 12 }}>
                            To learn more and get a form to start the process, go to www.cms.gov/nosurprises/consumers or call 1-800-985-3059.
                        </div>
                        
                        <div style={{ fontSize: '9pt', lineHeight: '1.3', marginBottom: 12 }}>
                            For questions or more information about your right to a Good Faith Estimate or the dispute process, visit www.cms.gov/nosurprises/consumers or call 1-800-985-3059.
                        </div>
                        
                        <div style={{ fontSize: '9pt', lineHeight: '1.3', marginBottom: 12, fontWeight: 'bold' }}>
                            Keep a copy of this Good Faith Estimate in a safe place or take pictures of it. You may need it if you are billed a higher amount.
                        </div>
                        
                     </div>
                </PDFExport>
            </div>
        </React.Fragment>
    );
}

export { GoodFaithEstimateExportBtn };
